import {COLORS} from "../../../constants";

export const FacebookIcon = () => (
  <svg viewBox="0 0 128 110" role="img">
      <title>Facebook</title>
    <path fill={COLORS.darkBlue} d="M53.41,104.3V60.2H38.58V42.68H53.41V28.81q0-11,6.16-17T75.94,5.7a96,96,0,0,1,13.48.77v15.6H80.18q-5.21,0-7.13,2.31-1.55,1.94-1.54,6.16V42.68H87.88L85.57,60.2H71.51v44.1Z"></path>
  </svg>
);
